import * as React from "react";
import "./FacesheetScore.scss";

export const FacesheetCaseClues = ({ caseClues }) => {
    return (
        <div className="facesheet-personal facesheet-score">
            <div className="score-reasons">
                <ul>
                    {caseClues.map((x, i) => {
                        return (
                            <>
                                <li key={`caseClue_${i}`}>
                                    <p>{x}</p>
                                </li>
                            </>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};
